import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.less';
// import queryString from 'query-string'

const propTypes = {
  fileId: PropTypes.string.isRequired,
};

class TencentVideoPLay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoHeight: 0,
    };
  }

  componentDidMount() {
    const { fileId } = this.props;
    const that = this;
    // eslint-disable-next-line no-undef
    const player = TCPlayer('player-container-id', {
      // player-container-id 为播放器容器ID，必须与html中一致
      // fileID: '5285890800740157517', // 请传入需要播放的视频filID 必须
      fileID: fileId,
      appID: '1257840373', // 请传入点播账号的appID 必须
      // 其他参数请在开发文档中查看
      controls: true,
      autoplay: true,
      playbackRates: [0.5, 1, 1.25, 1.5, 2], // 设置变速播放倍率选项，仅 HTML5 播放模式有效
      controlBar: {
        playToggle: true,
      },

      plugins: {
        ProgressMarker: true,
        ContinuePlay: {
          // 开启续播功能
          auto: true, // [可选] 是否在视频播放后自动续播
          text: '上次播放至 ', // [可选] 提示文案
          btnText: '恢复播放', // [可选] 按钮文案~
        },
      },
    });
    // 加载完成后获取一下video的高度
    player.on('ready', () => {
      document.addEventListener('touchstart', () => {
        document.querySelector('#player-container-id_html5_api').play();
      }, false);
      const videoHeight = document.querySelector('#player-container-id').offsetHeight;
      that.setState({
        videoHeight,
      });
      that.props.onValue(videoHeight);
    });
  }

  render() {
    const { videoHeight } = this.state;
    return (
      <div style={{ height: videoHeight }}>
        <video
          muted
          autoPlay
          className={styles.vjs_tech}
          id="player-container-id"
          webkit-playsinline=""
          playsInline
          x5-playsinline=""
          x-webkit-airplay="allow"
        >
          <track kind="captions" />
        </video>
      </div>
    );
  }
}

TencentVideoPLay.propTypes = propTypes;

export default TencentVideoPLay;
